import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPodcastById } from "@store/action/planning/PodcastAction";
import { useParams } from "react-router-dom";
import { BsMusicNoteList } from "react-icons/bs";
import { store } from "@store/StoreConfig";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import BreadCrumbs from "@components/breadcrumbs/index1";
import Comment from "./Comment";
import Filter from "../Filter";

const URL = process.env.REACT_APP_MICRO_PLANING_URL;

const PodcastId = () => {
  const podcast = useSelector((state) => state.podcastReducer);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const shareUrl = window.location.href;
  const id = useParams().id;
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const renderPodcast = () => {
    return (
      podcast?.single && (
        <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="artist_wrapper_content ms_cover">
                <img
                  src={podcast.single[0]?.empic}
                  className="img-responsive"
                  height="250px"
                  alt="img"
                />
                <div className="artist_wrapper_text">
                  <div className="artist_wrapper_left">
                    <h1> {podcast.single[0]?.podcastname}</h1>
                    <p>Emission : {podcast.single[0]?.emissionanme}</p>
                    <p>Episode : {podcast.single[0]?.episodename}</p>
                    <p>
                      {" "}
                      {t("Description :")} {podcast.single[0]?.episodedesc}
                    </p>
                    <p>
                      {" "}
                      {t("Date")}: {podcast.single[0]?.date}
                    </p>
                    <div className="artist_btn ms_cover">
                      <div className="lang_apply_btn">
                        {PlayerFrontOfficeReducer?.currentSong ===
                        podcast?.single[0]?.file_path ? (
                          <a>
                            <BsMusicNoteList size={20} />
                          </a>
                        ) : (
                          <a
                            onClick={() =>
                              store.dispatch(
                                addMusic({
                                  currentsong: podcast?.single[0]?.file_path,
                                  namesong: `${podcast?.single[0]?.podcastname}`,
                                  item_data: podcast?.single[0],
                                  has_video:
                                    podcast?.single[0]?.podcastname.endsWith(
                                      "mp4"
                                    ) && true,
                                  name_id: podcast?.single[0].podcastname,
                                  is_web_rtc: false,
                                })
                              )
                            }
                          >
                            <i className="flaticon-play-button"></i>
                            play
                          </a>
                        )}
                      </div>
                      <div className="cancel_wrapper">
                        <ul
                          className="blog-icon-podcast"
                          style={{
                            textAlign: "center",
                            marginTop: "8px",
                            marginLeft: "15px",
                          }}
                        >
                          <li>
                            <FacebookShareButton url={shareUrl}>
                              <FacebookIcon size={30} round={true} />
                            </FacebookShareButton>
                          </li>

                          <li>
                            <TwitterShareButton url={shareUrl}>
                              <TwitterIcon size={30} round={true} />
                            </TwitterShareButton>
                          </li>
                          <li>
                            <WhatsappShareButton url={shareUrl}>
                              <WhatsappIcon size={30} round={true} />
                            </WhatsappShareButton>
                          </li>
                          <li>
                            <FacebookMessengerShareButton url={shareUrl}>
                              <FacebookMessengerIcon size={30} round={true} />
                            </FacebookMessengerShareButton>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Comment t={t} />
        </div>
      )
    );
  };

  useEffect(() => {
    dispatch(getPodcastById(id));
  }, [dispatch, id]);

  return (
    <div>
      <BreadCrumbs breadCrumbTitle="Podcast Details" />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              store={podcast}
              dispatch={dispatch}
              setCurrentPage={() => {}}
            />
            {renderPodcast()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodcastId;
